import React, { useCallback, useMemo, useRef } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { TreeView } from '../../../../../common/components/layout';
import { getCenteredEntities, getEntitiesWithVisibility } from '../../../../../map/utils/mapFunctions';
import { UrbanAreaExact } from '../../../../../mission/models/UrbanArea';

const UrbanAreaTreeView = ({ urbanAreas, setUrbanAreas, setCenteredGeometries, disabled }) => {
  const handleUrbanAreasCenterClick = useCallback(
    (item) => {
      setCenteredGeometries(getCenteredEntities(urbanAreas, item.id));
    },
    [setCenteredGeometries, urbanAreas]
  );

  const handleUrbanAreasVisibilityClick = useCallback(
    (item, isToggled) => {
      setUrbanAreas((oldUrbanAreas) => getEntitiesWithVisibility(oldUrbanAreas, item.id, isToggled));
    },
    [setUrbanAreas]
  );

  const { current: urbanAreaItemActions } = useRef([
    { id: 'urbanArea-center', icons: { default: 'gps_fixed' }, onClick: handleUrbanAreasCenterClick },
    {
      id: 'urbanArea-visibility',
      icons: { default: 'visibility', toggled: 'visibility_off' },
      onClick: handleUrbanAreasVisibilityClick,
    },
  ]);
  const urbanAreaItems = useMemo(
    () => [
      {
        id: 'root',
        label: `${i18n.t('mission.details.urbanAreas')}: ${urbanAreas.length}`,
        actions: urbanAreaItemActions,
        disabled,
        children: urbanAreas.map((_, index) => ({
          id: index,
          label: _.name,
          actions: urbanAreaItemActions,
          disabled,
        })),
      },
    ],
    [disabled, urbanAreaItemActions, urbanAreas]
  );

  return <TreeView id="urbanAreas" items={urbanAreaItems} />;
};

UrbanAreaTreeView.propTypes = {
  urbanAreas: PropTypes.arrayOf(UrbanAreaExact),
  setUrbanAreas: PropTypes.func.isRequired,
  setCenteredGeometries: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

UrbanAreaTreeView.defaultProps = {
  urbanAreas: [],
  disabled: false,
};

export default UrbanAreaTreeView;
